<template>
  <router-view :campaign="campaign" v-if="campaign" />
</template>

<script>
import store from '@/store';

export default {
  name: 'campaign-view',

  created() {
    // computed.campaign can be null, if for example a user goes
    // to a wrong URL. We need to redirect to dashboard if so.
    if (!store.containsCampaignId(this.$route.params.campaignId)) {
      this.$router.replace('/');
    }
  },

  computed: {
    organization() {
      return store.state.organization;
    },

    campaign() {
      return {
        ...store.getCampaign(this.$route.params.campaignId),
        organization: this.organization,
      };
    },
  },
};
</script>
